<template>
  <li class="d-flex align-items-center border-bottom">
    <div class="shohin_group d-flex align-items-center my-3">
      <p>{{ index }}</p>
      <img :src="thumb" @error="noImage()" :alt="name" class="mx-4" />
      <p>{{ name }}</p>
    </div>
    <div v-if="useNum == 'True' && btotal != 'true'" class="shohin_quantity text-center my-3">
      <select v-model="quantity" class="w-auto px-3 select_no">
        <option v-for="n of nLimt" :key="n" :value="n">{{n}}</option>
      </select>
      個
      <button v-if="useDel == 'True'" v-on:click="delCart" class="btn ml-3">削除</button>
    </div>
    <div v-else-if="useDel == 'False' || bSet!='True'" class="shohin_quantity text-center my-3">{{quantity}}個</div>
    <div v-else class="shohin_quantity text-center my-3">{{quantity}}セット
      <button v-if="useDel == 'True'" v-on:click="delCart" class="btn set_delete">削除</button>
    </div>
    <div class="shohin_price my-3">
      <p class="text-right">{{ amount }}円</p>
    </div>
  </li>
</template>
<style scoped>
.set_delete {
  margin-left: 35px;
}
</style>
<script>
export default {
  props: ["index", "item","btotal"],
  data() {
    return {
      name: "",
      gdiv: "",
      code: "",
      no: "",
      option: "",
      quantity: "",
      amount: "",
      spkg: "",
      useNum: "",
      useDel: "",
      thumb: "",
      bSet:"True",
      nLimt:"",
      nNums:"",
    };
  },
  mounted() {
    this.name = this.item.name;
    this.gdiv = this.item.gdiv;
    this.code = this.item.code;
    this.no = this.item.no;
    this.nNums = parseInt(this.item.nNums);
    this.nLimt = parseInt(this.item.nLimt);
    this.quantity = this.item.quantity;
    this.amount = this.item.amount;
    this.spkg = this.item.spkg;
    this.useNum = this.item.useNum;
    this.useDel = this.item.useDel;
    this.thumb = process.env.VUE_APP_CONTENTS_PRODUCT_HOME + this.no + "/thumb.jpg";
      if(this.item.bSet) this.bSet = this.item.bSet;
  },
  watch: {
    quantity: function (newVal) {//mounted除外用
      if (newVal != this.item.quantity) { 
        this.$emit("putCart", [this.gdiv, this.code, this.quantity, 1]);
      }
    },
    item: function () {
      this.amount = this.item.amount;
    },
  },
  methods: {
    delCart() {
      this.$emit("delCart", [this.gdiv, this.code, this.spkg]);
    },
    noImage() {
      this.thumb = process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
  },
};
</script>